// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./radio-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./radio-1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Orange: #fe6100;
  --Green: #87bc45;
  --Red: #e00606;
  --WhiteSmoke: #f5f5f5;
  --White: #fff;
  --StockOrange: #ff7b29;
  --StockRed: #e00606;
  --SaddleBrown: #833505;
  --TotalBlack: #000000;
  --HightEmphasis: #212121;
  --LightBlack: #0f1d3e;
  --MediumEmphasis: #666;
  --LowEmphasis: #9e9e9e;
  --Gray88: #e0e0e0;
  --Gray85: #d9d9d9; }

.radio_content__ZU0IH {
  margin-bottom: 10px;
  /* Checked */
  /* Hover */
  /* Disabled */ }
  .radio_content__ZU0IH input[type='radio'] {
    display: none; }
  .radio_content__ZU0IH label {
    display: inline-block;
    cursor: pointer;
    position: relative;
    padding-left: 25px;
    margin-right: 0;
    line-height: 18px;
    -webkit-user-select: none;
            user-select: none; }
  .radio_content__ZU0IH label:before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    position: absolute;
    left: 0;
    bottom: 1px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 no-repeat; }
  .radio_content__ZU0IH input[type='radio']:checked + label:before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 0 0 no-repeat; }
  .radio_content__ZU0IH label:hover:before {
    filter: brightness(120%); }
  .radio_content__ZU0IH input[type='radio']:disabled + label:before {
    filter: grayscale(100%); }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.scss","webpack://./src/components/radio/radio.module.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAS;EACT,gBAAQ;EACR,cAAM;EACN,qBAAa;EACb,aAAQ;EACR,sBAAc;EACd,mBAAW;EACX,sBAAc;EAGd,qBAAa;EACb,wBAAgB;EAChB,qBAAa;EACb,sBAAiB;EACjB,sBAAc;EAGd,iBAAS;EACT,iBAAS,EAAA;;AClBX;EACE,mBAAmB;EAwBnB,YAAA;EAKA,UAAA;EAKA,aAAA,EAAc;EAnChB;IAGI,aAAa,EAAA;EAHjB;IAMI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB,EAAA;EAZrB;IAeI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,iEAA8C,EAAA;EAtBlD;IA2BI,iEAA8C,EAAA;EA3BlD;IAgCI,wBAAwB,EAAA;EAhC5B;IAqCI,uBAAuB,EAAA","sourcesContent":[":root {\n  // Product\n  --Orange: #fe6100;\n  --Green: #87bc45;\n  --Red: #e00606;\n  --WhiteSmoke: #f5f5f5;\n  --White: #fff;\n  --StockOrange: #ff7b29;\n  --StockRed: #e00606;\n  --SaddleBrown: #833505;\n\n  // On Surface\n  --TotalBlack: #000000;\n  --HightEmphasis: #212121;\n  --LightBlack: #0f1d3e;\n  --MediumEmphasis: #666;\n  --LowEmphasis: #9e9e9e;\n\n  // Border\n  --Gray88: #e0e0e0;\n  --Gray85: #d9d9d9;\n}\n","@import 'src/styles/colors.scss';\n\n.content {\n  margin-bottom: 10px;\n  & input[type='radio'] {\n    display: none;\n  }\n  & label {\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n    padding-left: 25px;\n    margin-right: 0;\n    line-height: 18px;\n    user-select: none;\n  }\n  & label:before {\n    content: '';\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    left: 0;\n    bottom: 1px;\n    background: url('./radio-2.svg') 0 0 no-repeat;\n  }\n\n  /* Checked */\n  & input[type='radio']:checked + label:before {\n    background: url('./radio-1.svg') 0 0 no-repeat;\n  }\n\n  /* Hover */\n  & label:hover:before {\n    filter: brightness(120%);\n  }\n\n  /* Disabled */\n  & input[type='radio']:disabled + label:before {\n    filter: grayscale(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `radio_content__ZU0IH`
};
export default ___CSS_LOADER_EXPORT___;
